import { useState, useEffect, useCallback } from 'react';
import { tallerService, orderService } from '../services/api';
import Navbar from '../components/Navbar';
import OrderDetail from '../components/OrderDetail';

const TIPOS_TAPIZADOS = ['Sofá', 'Sofá cama', 'Sala / Juego de sala', 'Sillón / Reclinable', 'Butaca', 'Diván', 'Cojines', 'Bancos con Tela', 'Coqueta', 'Juego de Comedor'];

export default function Taller() {
  const [tab, setTab] = useState('trabajo');
  const [busqueda, setBusqueda] = useState('');
  const [items, setItems] = useState([]);
  const [trabajos, setTrabajos] = useState([]);
  const [operarios, setOperarios] = useState([]);
  const [telas, setTelas] = useState([]);
  const [tarifas, setTarifas] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [asignando, setAsignando] = useState(null);
  const [form, setForm] = useState({ operario_id: '', tela_metraje: '', nota: '' });
  const [ordenSel, setOrdenSel] = useState(null);

  const cargar = useCallback(async () => {
    setLoading(true);
    try {
      const [pend, ops, tel, tar] = await Promise.all([
        tallerService.pendientes(),
        tallerService.operarios(),
        tallerService.telas(),
        tallerService.tarifas(),
      ]);
      setItems(pend.data.items || []);
      setTrabajos(pend.data.trabajos || []);
      setOperarios(ops.data || []);
      setTelas(tel.data || []);
      setTarifas(tar.data || []);
      setError('');
    } catch (err) {
      setError('Error al cargar el taller');
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { cargar(); }, [cargar]);

  const verOrden = async (orderId) => {
    try {
      const res = await orderService.getOne(orderId);
      setOrdenSel(res.data);
    } catch (err) {
      alert('No se pudo cargar la orden');
    }
  };

  const trabajoDe = (orderId, itemId, unidad, etapa) => trabajos.find(t => t.order_id === orderId && t.etapa === etapa && t.item_id === itemId && t.unidad_index === unidad)
    || trabajos.find(t => t.order_id === orderId && t.etapa === etapa && t.item_id == null && unidad === 1);

  const abrirAsignar = (orden, art, unidad, etapa) => {
    setAsignando({ order_id: orden.id, item_id: art.item_id, unidad_index: unidad, etapa, numero: orden.numero, articulo: art.articulo, cantidad: art.cantidad, tela_catalogo: art.tela_catalogo, tela_codigo: art.tela_codigo });
    setForm({ operario_id: '', tela_metraje: '', nota: '', rubro: '' });
  };

  const guardarAsignacion = async () => {
    if (!form.operario_id) { alert('Elegí un operario'); return; }
    if (!form.rubro) { alert('Elegí el tipo de trabajo (rubro)'); return; }
    try {
      await tallerService.asignar({
        order_id: asignando.order_id,
        item_id: asignando.item_id,
        unidad_index: asignando.unidad_index,
        etapa: asignando.etapa,
        operario_id: Number(form.operario_id),
        tela_metraje: form.tela_metraje || null,
        nota: form.nota || null,
        rubro: form.rubro,
      });
      setAsignando(null);
      cargar();
    } catch (err) {
      alert(err.response?.data?.error || 'Error al asignar');
    }
  };

  const quitar = async (trabajoId) => {
    if (!window.confirm('¿Quitar esta asignación?')) return;
    try {
      await tallerService.quitar(trabajoId);
      cargar();
    } catch (err) {
      alert(err.response?.data?.error || 'Error al quitar');
    }
  };

  const marcarTela = async (orderId, estado) => {
    try {
      await tallerService.marcarTela(orderId, estado);
      cargar();
    } catch (err) {
      alert('Error al marcar la tela');
    }
  };

  const guardarMetraje = async (itemId, metraje) => {
    try {
      await tallerService.editarMetraje(itemId, metraje);
      cargar();
    } catch (err) {
      alert('Error al guardar el metraje');
    }
  };

  const s = {
    page: { minHeight: '100vh', background: '#f5f0e8' },
    container: { maxWidth: 1100, margin: '0 auto', padding: 20 },
    card: { background: '#fff', borderRadius: 12, padding: 20, marginBottom: 16, boxShadow: '0 1px 3px rgba(0,0,0,0.1)' },
    etapaBox: { border: '1px solid #e0d0c0', borderRadius: 8, padding: 12, flex: 1 },
    btnAsignar: { background: '#5c3d2e', color: '#fff', border: 'none', padding: '6px 14px', borderRadius: 6, cursor: 'pointer', fontSize: 13 },
    btnQuitar: { background: '#fff', color: '#c0392b', border: '1px solid #c0392b', padding: '4px 10px', borderRadius: 6, cursor: 'pointer', fontSize: 12 },
    label: { display: 'block', fontSize: 12, color: '#5c3d2e', marginBottom: 4, fontWeight: 600 },
    input: { width: '100%', padding: 8, border: '1px solid #ccc', borderRadius: 6, fontSize: 14, boxSizing: 'border-box' },
    badge: (done) => ({ display: 'inline-block', padding: '2px 8px', borderRadius: 10, fontSize: 11, fontWeight: 600, background: done ? '#d4f4dd' : '#fff3cd', color: done ? '#1e7e34' : '#856404' }),
    tab: (active) => ({ padding: '10px 20px', border: 'none', borderRadius: 8, cursor: 'pointer', fontSize: 14, fontWeight: 600, background: active ? '#5c3d2e' : '#e8ddd0', color: active ? '#fff' : '#5c3d2e', marginRight: 8 }),
    numeroLink: { color: '#5c3d2e', fontSize: 16, cursor: 'pointer', textDecoration: 'underline', fontWeight: 700 },
  };

  const ordenesTodas = [];
  const vistos = {};
  items.forEach(it => {
    if (!vistos[it.id]) { vistos[it.id] = { ...it, articulos: [] }; ordenesTodas.push(vistos[it.id]); }
    vistos[it.id].articulos.push(it);
  });
  const b = busqueda.trim().toLowerCase();
  const ordenes = b
    ? ordenesTodas.filter(o => (o.numero || '').toLowerCase().includes(b) || (o.cliente || '').toLowerCase().includes(b))
    : ordenesTodas;

  const ordenesTela = [];
  const vistosTela = {};
  telas.forEach(t => {
    if (!vistosTela[t.order_id]) { vistosTela[t.order_id] = { order_id: t.order_id, numero: t.numero, cliente: t.cliente, tela_estado: t.tela_estado, tela_fecha_pedido: t.tela_fecha_pedido, delivery_date: t.delivery_date, articulos: [] }; ordenesTela.push(vistosTela[t.order_id]); }
    vistosTela[t.order_id].articulos.push(t);
  });

  const imprimirPedido = () => {
    const pendientes = ordenesTela.filter(o => o.tela_estado !== 'Pedido');
    let filas = '';
    pendientes.forEach(o => {
      o.articulos.forEach(a => {
        filas += `<tr>
          <td>${o.numero}</td>
          <td>${a.tela_catalogo || '—'} ${a.tela_codigo ? '(' + a.tela_codigo + ')' : ''}</td>
          <td>${a.tela_metraje ? a.tela_metraje + ' m' : 'PENDIENTE'}</td>
          <td>${o.delivery_date ? new Date(o.delivery_date).toLocaleDateString('es-CR') : '—'}</td>
        </tr>`;
      });
    });
    const html = `<html><head><title>Pedido de Telas</title>
      <style>
        body{font-family:Arial;padding:20px;}
        h1{color:#5c3d2e;font-size:20px;}
        table{width:100%;border-collapse:collapse;margin-top:12px;}
        th{background:#5c3d2e;color:#fff;padding:8px;text-align:left;font-size:13px;}
        td{padding:8px;border-bottom:1px solid #ddd;font-size:13px;}
      </style></head><body>
      <h1>Pedido de Telas — ${new Date().toLocaleDateString('es-CR')}</h1>
      <table><thead><tr><th>Orden</th><th>Tela</th><th>Metros</th><th>Entrega</th></tr></thead>
      <tbody>${filas || '<tr><td colspan="4">No hay telas pendientes de pedir</td></tr>'}</tbody></table>
      </body></html>`;
    const v = window.open('', '_blank');
    v.document.write(html);
    v.document.close();
    v.print();
  };

  return (
    <div style={s.page}>
      <Navbar />
      <div style={s.container}>
        <h1 style={{ color: '#5c3d2e', fontSize: 22 }}>🧵 Taller</h1>

        <div style={{ marginBottom: 16 }}>
          <button style={s.tab(tab === 'trabajo')} onClick={() => setTab('trabajo')}>Asignar Trabajo</button>
          <button style={s.tab(tab === 'telas')} onClick={() => setTab('telas')}>Compra de Telas</button>
        </div>

        {loading && <p>Cargando…</p>}
        {error && <p style={{ color: '#c0392b' }}>{error}</p>}

        {tab === 'trabajo' && !loading && (
          <>
            <input
              type="text"
              placeholder="🔍 Buscar por orden o cliente..."
              value={busqueda}
              onChange={e => setBusqueda(e.target.value)}
              style={{ width: '100%', padding: 12, border: '1px solid #ccc', borderRadius: 8, fontSize: 14, marginBottom: 16, boxSizing: 'border-box' }}
            />
            {ordenes.length === 0 && <div style={s.card}>{busqueda ? 'No se encontraron órdenes con esa búsqueda.' : 'No hay muebles tapizados en taller por ahora.'}</div>}
            {ordenes.map(orden => {
              const tapizados = orden.articulos.filter(a => TIPOS_TAPIZADOS.includes(a.tipo));
              if (tapizados.length === 0) return null;
              return (
                <div key={orden.id} style={s.card}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 10 }}>
                    <div>
                      <strong style={s.numeroLink} onClick={() => verOrden(orden.id)}>{orden.numero}</strong>
                      <span style={{ color: '#8a7a6a', marginLeft: 10 }}>{orden.cliente}</span>
                    </div>
                    {orden.delivery_date && <span style={{ fontSize: 12, color: '#8a7a6a' }}>Entrega: {new Date(orden.delivery_date).toLocaleDateString('es-CR')}</span>}
                  </div>

                  {tapizados.map(a => {
                    const cant = a.cantidad && a.cantidad > 0 ? a.cantidad : 1;
                    return (
                      <div key={a.item_id} style={{ marginBottom: 14 }}>
                        <div style={{ fontSize: 14, color: '#333', marginBottom: 8 }}>
                          • <strong>{a.tipo}</strong> — {a.articulo}
                          {cant > 1 && <span style={{ color: '#a0522d', fontWeight: 600 }}> ×{cant}</span>}
                          {a.tela_catalogo && <span style={{ color: '#8a7a6a' }}> · Tela: {a.tela_catalogo} {a.tela_codigo ? `(${a.tela_codigo})` : ''}</span>}
                        </div>
                        {Array.from({ length: cant }, (_, i) => i + 1).map(u => {
                          const tCostura = trabajoDe(orden.id, a.item_id, u, 'costura');
                          const tTapiceria = trabajoDe(orden.id, a.item_id, u, 'tapiceria');
                          return (
                            <div key={u} style={{ border: '1px solid #e8ddd0', borderRadius: 8, padding: 10, marginBottom: 8, background: '#faf6f0' }}>
                              {cant > 1 && <div style={{ fontSize: 12, color: '#5c3d2e', fontWeight: 700, marginBottom: 6 }}>Unidad {u} de {cant}</div>}
                              <div style={{ display: 'flex', gap: 12 }}>
                                <div style={s.etapaBox}>
                                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 8 }}>
                                    <strong style={{ color: '#5c3d2e' }}>Costura</strong>
                                    {tCostura && tCostura.operario_id && <span style={s.badge(tCostura.estado === 'Terminado')}>{tCostura.estado}</span>}
                                  </div>
                                  {tCostura && tCostura.operario_id ? (
                                    <div style={{ fontSize: 13 }}>
                                      <div>👤 {tCostura.operario}</div>
                                      {tCostura.estado !== 'Terminado' && <button style={{ ...s.btnQuitar, marginTop: 6 }} onClick={() => quitar(tCostura.id)}>Quitar</button>}
                                    </div>
                                  ) : (
                                    <button style={s.btnAsignar} onClick={() => abrirAsignar(orden, a, u, 'costura')}>Asignar costurera</button>
                                  )}
                                </div>
                                <div style={s.etapaBox}>
                                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 8 }}>
                                    <strong style={{ color: '#5c3d2e' }}>Tapicería</strong>
                                    {tTapiceria && <span style={s.badge(tTapiceria.estado === 'Terminado')}>{tTapiceria.estado}</span>}
                                  </div>
                                  {tTapiceria ? (
                                    <div style={{ fontSize: 13 }}>
                                      <div>👤 {tTapiceria.operario}</div>
                                      {tTapiceria.estado !== 'Terminado' && <button style={{ ...s.btnQuitar, marginTop: 6 }} onClick={() => quitar(tTapiceria.id)}>Quitar</button>}
                                    </div>
                                  ) : (
                                    <button style={s.btnAsignar} onClick={() => abrirAsignar(orden, a, u, 'tapiceria')}>Asignar tapicero</button>
                                  )}
                                </div>
                              </div>
                            </div>
                          );
                        })}
                      </div>
                    );
                  })}
                </div>
              );
            })}
          </>
        )}

        {tab === 'telas' && !loading && (
          <>
            <div style={{ marginBottom: 12 }}>
              <button style={{ background: '#a0522d', color: '#fff', border: 'none', padding: '8px 16px', borderRadius: 8, cursor: 'pointer', fontSize: 14, fontWeight: 600 }} onClick={imprimirPedido}>🖨️ Imprimir pedido (pendientes)</button>
            </div>
            {ordenesTela.length === 0 && <div style={s.card}>No hay órdenes con tela en taller por ahora.</div>}
            {ordenesTela.map(orden => {
              const pedido = orden.tela_estado === 'Pedido';
              return (
                <div key={orden.order_id} style={{ ...s.card, borderLeft: pedido ? '4px solid #1e7e34' : '4px solid #f59e0b' }}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 10 }}>
                    <div>
                      <strong style={s.numeroLink} onClick={() => verOrden(orden.order_id)}>{orden.numero}</strong>
                      <span style={{ color: '#8a7a6a', marginLeft: 10 }}>{orden.cliente}</span>
                      {orden.delivery_date && <span style={{ fontSize: 12, color: '#8a7a6a', marginLeft: 10 }}>Entrega: {new Date(orden.delivery_date).toLocaleDateString('es-CR')}</span>}
                    </div>
                    <span style={s.badge(pedido)}>{pedido ? 'Pedido ✓' : 'Pendiente de pedir'}</span>
                  </div>

                  {orden.articulos.map(a => (
                    <div key={a.item_id} style={{ fontSize: 14, color: '#333', marginBottom: 10, paddingLeft: 8, borderBottom: '1px solid #f0e8e0', paddingBottom: 8 }}>
                      • <strong>{a.tipo}</strong> — {a.articulo}
                      <div style={{ color: '#8a7a6a', fontSize: 13, marginTop: 2 }}>
                        Tela: {a.tela_catalogo || '—'} {a.tela_codigo ? `(${a.tela_codigo})` : ''}
                      </div>
                      <div style={{ display: 'flex', gap: 8, marginTop: 6, alignItems: 'center' }}>
                        <input type="number" step="0.01" placeholder="Metros" defaultValue={a.tela_metraje || ''} id={`met-${a.item_id}`} style={{ ...s.input, width: 110 }} />
                        <button style={{ ...s.btnAsignar, padding: '5px 10px', fontSize: 12 }} onClick={() => guardarMetraje(a.item_id, document.getElementById(`met-${a.item_id}`).value)}>Guardar</button>
                        {!a.tela_metraje && <span style={{ color: '#c0392b', fontSize: 12 }}>Pendiente de metraje</span>}
                      </div>
                    </div>
                  ))}

                  <div style={{ display: 'flex', gap: 8, marginTop: 10, alignItems: 'center' }}>
                    {orden.tela_fecha_pedido && <span style={{ fontSize: 12, color: '#8a7a6a' }}>Pedido: {new Date(orden.tela_fecha_pedido).toLocaleDateString('es-CR')}</span>}
                    {pedido
                      ? <button style={s.btnQuitar} onClick={() => marcarTela(orden.order_id, 'Pendiente')}>Marcar pendiente</button>
                      : <button style={{ background: '#1e7e34', color: '#fff', border: 'none', padding: '6px 14px', borderRadius: 6, cursor: 'pointer', fontSize: 13 }} onClick={() => marcarTela(orden.order_id, 'Pedido')}>Marcar pedido</button>}
                  </div>
                </div>
              );
            })}
          </>
        )}
      </div>

      {ordenSel && (
        <OrderDetail order={ordenSel} onClose={() => setOrdenSel(null)} onStatusChange={() => {}} onOrderSaved={() => { setOrdenSel(null); cargar(); }} />
      )}

      {asignando && (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000 }} onClick={() => setAsignando(null)}>
          <div style={{ background: '#fff', borderRadius: 12, padding: 24, width: 400, maxWidth: '90%' }} onClick={e => e.stopPropagation()}>
            <h2 style={{ color: '#5c3d2e', fontSize: 18, marginTop: 0 }}>Asignar {asignando.etapa === 'costura' ? 'Costura' : 'Tapicería'}</h2>
            <p style={{ fontSize: 13, color: '#8a7a6a' }}>{asignando.numero} — {asignando.articulo}</p>
            <label style={s.label}>Operario *</label>
            <select style={s.input} value={form.operario_id} onChange={e => setForm(p => ({ ...p, operario_id: e.target.value }))}>
              <option value="">— Seleccionar —</option>
              {operarios.map(o => <option key={o.id} value={o.id}>{o.name}</option>)}
            </select>
            <label style={{ ...s.label, marginTop: 12 }}>Tipo de trabajo *</label>
            <select style={s.input} value={form.rubro} onChange={e => setForm(p => ({ ...p, rubro: e.target.value }))}>
              <option value="">— Seleccionar —</option>
              {tarifas.map(t => <option key={t.id} value={t.rubro}>{t.rubro}</option>)}
            </select>
            <label style={{ ...s.label, marginTop: 12 }}>Nota (opcional)</label>
            <input style={s.input} value={form.nota} onChange={e => setForm(p => ({ ...p, nota: e.target.value }))} />
            <div style={{ display: 'flex', gap: 8, marginTop: 20 }}>
              <button style={{ ...s.btnAsignar, flex: 1 }} onClick={guardarAsignacion}>Asignar</button>
              <button style={{ background: '#eee', color: '#333', border: 'none', padding: '6px 14px', borderRadius: 6, cursor: 'pointer', flex: 1 }} onClick={() => setAsignando(null)}>Cancelar</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
